import axios from "axios";
import { OpenAPI } from "../../../common/api/openapi";
import type { KscResponseModel } from "../../../common/core/request";
import type {
  DescribeAddonsParam,
  DescribeAddonsResponse,
  // DescribeAddonInstancesParam,
  // DescribeAddonInstancesResponse,
  // CreateAddonInstanceParam,
  CreateAddonInstanceResponse,
  DeleteAddonInstanceParam,
  DeleteAddonInstanceResponse,
} from "./types";
import {
  CheckAddonInstanceNameExistResponseSchema,
  CreateAddonInstanceResponseSchema,
  DeleteAddonInstanceResponseSchema,
  DescribeAddonInstancesResponseSchema,
  DescribeAddonListResponseSchema,
  ModifyAddonInstanceResponseSchema,
  DescribeIngressNginxLoadBalancerResponseSchema,
  type CreateAddonInstanceParam,
  type CheckAddonInstanceNameExistParam,
  type DescribeAddonInstancesParam,
  type ModifyAddonInstanceParam,
  type ModifyAddonInstanceResponse,
  type DescribeIngressNginxLoadBalancerParam,
} from "./schema/addon";
import type { Param } from "@kce2/common/api/types";
import { axiosInstance } from "@kce2/app/axios";
import { AxiosRESTDataSource } from "@kce2/common/api/v2/rest-data-source";

const req = new OpenAPI("/api/cluster");

export async function describeNetworkPlugins(params: DescribeAddonsParam) {
  return axios<KscResponseModel<DescribeAddonsResponse>>(
    req.get("DescribeNetworkAddonList", params.Region, { params }),
  );
}

/**
 * @deprecated 使用 addonApi
 */
export async function describeAddons(params: DescribeAddonsParam) {
  return axios<KscResponseModel<DescribeAddonsResponse>>(
    req.get("DescribeAddonList", params.Region, {
      params,
    }),
  );
}

/**
 * @deprecated 使用 addonApi
 */
export async function describeAddonInstances(params: Param<DescribeAddonInstancesParam>) {
  return addonApi.describeAddonInstances(params);
}

/**
 * @deprecated 使用 addonApi
 */
export async function createAddonInstance(params: Param<CreateAddonInstanceParam>) {
  return axios<CreateAddonInstanceResponse>(
    req.post("CreateAddonInstance", params.Region, { body: params }),
  );
}

/**
 * @deprecated 使用 addonApi
 */
export async function modifyAddonInstance({ Region, ...params }: Param<ModifyAddonInstanceParam>) {
  return axios<ModifyAddonInstanceResponse>(
    req.post("ModifyAddonInstance", Region, { body: params }),
  );
}

/**
 * @deprecated 使用 addonApi
 */
export async function deleteAddonInstance(params: DeleteAddonInstanceParam) {
  return axios<DeleteAddonInstanceResponse>(
    req.post("DeleteAddonInstance", params.Region, { body: params }),
  );
}

class AddonAPI extends AxiosRESTDataSource {
  baseURL = "/api/cluster";

  async checkAddonInstanceNameExist({
    Region,
    ...params
  }: Param<CheckAddonInstanceNameExistParam>) {
    const res = await this.post("", CheckAddonInstanceNameExistResponseSchema, {
      Action: "CheckAddonInstanceNameExist",
      Region,
      body: params,
    });

    return res.data.Data ?? false;
  }

  async describeAddons({ Region, ...params }: Param<DescribeAddonsParam>) {
    return this.post("", DescribeAddonListResponseSchema, {
      Action: "DescribeAddonList",
      Region,
      body: params,
    });
  }

  async describeNetworkPlugins(params: DescribeAddonsParam) {
    return axios<KscResponseModel<DescribeAddonsResponse>>(
      req.get("DescribeNetworkAddonList", params.Region, { params }),
    );
  }

  async describeAddonInstances({ Region, ...params }: Param<DescribeAddonInstancesParam>) {
    return this.post("", DescribeAddonInstancesResponseSchema, {
      Action: "DescribeAddonInstances",
      Region,
      body: params,
    });
  }

  async createAddonInstance({ Region, ...params }: Param<CreateAddonInstanceParam>) {
    return this.post("", CreateAddonInstanceResponseSchema, {
      Action: "CreateAddonInstance",
      Region,
      body: params,
    });
  }

  async modifyAddonInstance({ Region, ...params }: Param<ModifyAddonInstanceParam>) {
    return this.post("", ModifyAddonInstanceResponseSchema, {
      Action: "ModifyAddonInstance",
      Region,
      body: params,
    });
  }

  async deleteAddonInstance({ Region, ...params }: Param<DeleteAddonInstanceParam>) {
    return this.post("", DeleteAddonInstanceResponseSchema, {
      Action: "DeleteAddonInstance",
      Region,
      body: params,
    });
  }

  async describeAIAddonList(params: Omit<DescribeAddonsParam, "Type">) {
    return this.post("", DescribeAddonListResponseSchema, {
      Action: "DescribeAddonList",
      Region: params.Region,
      body: { ...params, Category: "AI" },
    });
  }

  async describeIngressNginxLoadBalancer(params: Param<DescribeIngressNginxLoadBalancerParam>) {
    return this.post("", DescribeIngressNginxLoadBalancerResponseSchema, {
      Action: "DescribeIngressNginxLoadBalancer",
      Region: params.Region,
      body: params,
    });
  }
}
export const addonApi = new AddonAPI(axiosInstance);
